import PropTypes from 'prop-types';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';
import { Button } from '@mui/material';
import { LogoutOutlined } from '@ant-design/icons';
import { useDispatch } from 'store';
import { logout } from 'slices/auth';
import { useNavigate } from 'react-router';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await dispatch(logout());
    navigate('/login');
  };

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '60px',
        width: 'inherit',
        paddingTop: '8px',
        paddingBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
      <Button sx={{ fontWeight: 500 }} variant="outlined" endIcon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Button>
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool
};

export default DrawerHeader;
